import { render, staticRenderFns } from "./approveUser_page.vue?vue&type=template&id=56e77a25&scoped=true&"
import script from "./approveUser_page.vue?vue&type=script&lang=js&"
export * from "./approveUser_page.vue?vue&type=script&lang=js&"
import style0 from "./approveUser_page.vue?vue&type=style&index=0&id=56e77a25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e77a25",
  null
  
)

export default component.exports